module.exports = __webpack_public_path__ + "static/img/logo.8b51f80.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/chaoxinxing/logo.svg
// module id = 1873
// module chunks = 0